var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_66606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12H11.25M5.66829 2.66537L3.50163 4.3987C2.76657 4.98674 2.39904 5.28077 2.1345 5.64571C1.90013 5.96902 1.72577 6.33181 1.61971 6.71678C1.5 7.15134 1.5 7.622 1.5 8.56333V11.1667C1.5 13.0335 1.5 13.9669 1.86331 14.68C2.18289 15.3072 2.69282 15.8171 3.32003 16.1367C4.03307 16.5 4.96649 16.5 6.83333 16.5H11.1667C13.0335 16.5 13.9669 16.5 14.68 16.1367C15.3072 15.8171 15.8171 15.3072 16.1367 14.68C16.5 13.9669 16.5 13.0335 16.5 11.1667V8.56333C16.5 7.622 16.5 7.15134 16.3803 6.71678C16.2742 6.33181 16.0999 5.96902 15.8655 5.64571C15.601 5.28077 15.2334 4.98674 14.4984 4.3987L12.3317 2.66537C11.1426 1.71412 10.5481 1.23849 9.88877 1.05609C9.30718 0.895192 8.69282 0.895192 8.11123 1.05609C7.45188 1.23849 6.85735 1.71412 5.66829 2.66537Z",
    stroke: "#00FEAE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_66606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSelected);
export default __webpack_public_path__ + "static/media/home-selected.36e4908e2f98038a7d71939b15ea48ea.svg";
export { ForwardRef as ReactComponent };